export default "__VITE_ASSET__Chx6V8_R__"